import { render, staticRenderFns } from "./ContentContainer.vue?vue&type=template&id=09bc07ce&"
import script from "./ContentContainer.vue?vue&type=script&lang=js&"
export * from "./ContentContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports